import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import toast from 'react-hot-toast'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function VegetableShopDetails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Vegetable/item/getbyvegetableid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [dvegetableData, setVegetableData] = useState({

        vegetableId: id,
        name: "",
        dailyPurchase: 0,
        wastage: 0,
        morningSale: 0,
        morningPrice: 0,
        netQuantity: 0,
        purchasePrice: 0,
        sellingPrice: 0,
        purchaseCost: 0,
        sellingIncome: 0,
        dailyIncome: 0,
        latitude: "",
        longitude: ""

    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setVegetableData({ ...dvegetableData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Vegetable/item`, dvegetableData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }


    const calculateMonthlyRevenue = () => {
        const result = dvegetableData.dailyPurchase * 0.1
        setVegetableData(prev => ({
            ...prev,
            wastage: result
        }))
    };

    const calculateLateMorningSale = () => {
        const result = dvegetableData.dailyPurchase * 0.1
        setVegetableData(prev => ({
            ...prev,
            morningSale: result
        }))
    };

    const calculateNetQuantity = () => {
        const result = dvegetableData.dailyPurchase - (dvegetableData.morningSale + dvegetableData.wastage)
        setVegetableData(prev => ({
            ...prev,
            netQuantity: result
        }))
    };

    const calculatePerMonth = () => {
        const result = dvegetableData.purchasePrice * dvegetableData.dailyPurchase
        setVegetableData(prev => ({
            ...prev,
            purchaseCost: result
        }))
    };

    const calculateSellingPrice = () => {
        const result = (dvegetableData.netQuantity * dvegetableData.sellingPrice) + (dvegetableData.morningSale * dvegetableData.morningPrice)
        setVegetableData(prev => ({
            ...prev,
            sellingIncome: result
        }))
    };

    const calculateDailyIncome = () => {
        const result = dvegetableData.sellingIncome - dvegetableData.purchaseCost
        setVegetableData(prev => ({
            ...prev,
            dailyIncome: result
        }))
    };

    // // //   React.useEffect(() => { fetchIncomeData(); fetchAreaType(); fetchCurentLocation(); }, []);

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [dvegetableData.dailyPurchase]);

    React.useEffect(() => {
        calculateLateMorningSale();
    }, [dvegetableData.dailyPurchase, dvegetableData.morningPrice, dvegetableData.wastage])

    React.useEffect(() => {
        calculateNetQuantity();
    }, [dvegetableData.dailyPurchase, dvegetableData.morningSale, dvegetableData.wastage]);

    React.useEffect(() => {
        calculatePerMonth();
    }, [dvegetableData.purchasePrice, dvegetableData.dailyPurchase]);

    React.useEffect(() => {
        calculateSellingPrice();
    }, [dvegetableData.sellingPrice, dvegetableData.netQuantity, dvegetableData.morningPrice, dvegetableData.morningSale]);

    React.useEffect(() => {
        calculateDailyIncome();
    }, [dvegetableData.sellingIncome, dvegetableData.purchaseCost]);

    // Edit func


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Vegetable/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setVegetableData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Vegetable/item/${id}`, dvegetableData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
               UpdatedToast("Successfully updated")
                handleCancel()
                getSingleUser()
            }
            
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }


    const columns = [
        {
            title: "Vegetable",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Daily Purchase",
            dataIndex: "dailyPurchase",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Daily Income",
            dataIndex: "dailyIncome",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Wastages",
            dataIndex: "wastage",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Morning Sale",
            dataIndex: "morningSale",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Morning Price",
            dataIndex: "morningPrice",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Purchase Cost",
            dataIndex: "purchaseCost",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Purchase Price",
            dataIndex: "purchasePrice",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Selling Price",
            dataIndex: "sellingPrice",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Selling Income",
            dataIndex: "sellingIncome",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];

    async function handleCancel() {
        setVegetableData({
            ...dvegetableData,
            vegetableId: id,
            name: "",
            dailyPurchase: 0,
            wastage: 0,
            morningSale: 0,
            morningPrice: 0,
            netQuantity: 0,
            purchasePrice: 0,
            sellingPrice: 0,
            purchaseCost: 0,
            sellingIncome: 0,
            dailyIncome: 0,
        })
        setIsModalOpen(false)
        setIsEditModalOpen(false);
    }

    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Vegetable</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Vegetable</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                title={<h4>Edit Vegetable </h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Vegetable Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Vegetables
                                    </label>
                                    <input className="form-control" type="text" placeholder="vegetables" value={dvegetableData.name} onChange={(e) => setVegetableData({ ...dvegetableData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Daily purchase Qty(kg):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter daily purchase qty(kg)" value={dvegetableData.dailyPurchase} onChange={(e) => setVegetableData({ ...dvegetableData, dailyPurchase: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">wastage (Kg) @10%: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.wastage.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Last Morning Sale Qty: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.morningSale.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Net Quantity: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.netQuantity.toFixed(2)}</span>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Purchase Price(kg):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Purchase Price(kg)" value={dvegetableData.purchasePrice} onChange={(e) => setVegetableData({ ...dvegetableData, purchasePrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price(kg):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Selling Price(kg)" value={dvegetableData.sellingPrice} onChange={(e) => setVegetableData({ ...dvegetableData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Late morning Selling Price:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Late morning Selling Price" value={dvegetableData.morningPrice} onChange={(e) => setVegetableData({ ...dvegetableData, morningPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Purchase Cost: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.purchaseCost.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Selling Cost: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.sellingIncome.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.dailyIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Edit modal */}

            <Modal
                title={<h4>Edit Vegetable </h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => setIsEditModalOpen(false)}
                footer={[
                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(dvegetableData.id)}>Submit</button>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Vegetable Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Vegetables
                                    </label>
                                    <input className="form-control" type="text" placeholder="Vegetables" value={dvegetableData.name} onChange={(e) => setVegetableData({ ...dvegetableData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Daily purchase Qty(kg):
                                    </label>
                                    <input className="form-control" type="number" placeholder="daily purchase qty(kg)" value={dvegetableData.dailyPurchase} onChange={(e) => setVegetableData({ ...dvegetableData, dailyPurchase: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">wastage (Kg) @10%: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.wastage.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Last Morning Sale Qty: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.morningSale.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Net Quantity: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.netQuantity.toFixed(2)}</span>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Purchase Price(kg):
                                    </label>
                                    <input className="form-control" type="text" placeholder=" Purchase Price(kg)" value={dvegetableData.purchasePrice} onChange={(e) => setVegetableData({ ...dvegetableData, purchasePrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price(kg):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Selling Price" value={dvegetableData.sellingPrice} onChange={(e) => setVegetableData({ ...dvegetableData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Late morning Selling Price:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter late morning selling price" value={dvegetableData.morningPrice} onChange={(e) => setVegetableData({ ...dvegetableData, morningPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Purchase Cost: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.purchaseCost.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Selling Cost: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.sellingIncome.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dvegetableData.dailyIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

        </>
    )
}

export default VegetableShopDetails
